interface ShapeLIAProps {
  color?: string;
}

const ShapeLIA = ({ color }: ShapeLIAProps) => {
  const fillColor = color || 'url(#paint0_linear_128_28110)';
  
  return (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 6.25C3 4.45507 4.45507 3 6.25 3H17.75C19.5449 3 21 4.45507 21 6.25V17.75C21 19.5449 19.5449 21 17.75 21H6.25C4.45507 21 3 19.5449 3 17.75V6.25ZM6.25 4.5C5.2835 4.5 4.5 5.2835 4.5 6.25V6.5H19.5V6.25C19.5 5.2835 18.7165 4.5 17.75 4.5H6.25ZM4.5 17.75C4.5 18.7165 5.2835 19.5 6.25 19.5H17.75C18.7165 19.5 19.5 18.7165 19.5 17.75V8H4.5V17.75ZM6.85 9.5H10.15C10.6194 9.5 11 9.88056 11 10.35V17.15C11 17.6194 10.6194 18 10.15 18H6.85C6.38056 18 6 17.6194 6 17.15V10.35C6 9.88056 6.38056 9.5 6.85 9.5ZM7.5 16.5H9.5V11H7.5V16.5ZM12 10.25C12 9.83579 12.3358 9.5 12.75 9.5H17.25C17.6642 9.5 18 9.83579 18 10.25C18 10.6642 17.6642 11 17.25 11H12.75C12.3358 11 12 10.6642 12 10.25ZM12.75 12.5C12.3358 12.5 12 12.8358 12 13.25C12 13.6642 12.3358 14 12.75 14H16.25C16.6642 14 17 13.6642 17 13.25C17 12.8358 16.6642 12.5 16.25 12.5H12.75Z" fill={fillColor}/>
{!color && (
<defs>
<linearGradient id="paint0_linear_128_28110" x1="3.24258" y1="3" x2="21.2426" y2="21" gradientUnits="userSpaceOnUse">
<stop stopColor="#BAE8FF"/>
<stop offset="0.25" stopColor="#82BBFF"/>
<stop offset="0.75" stopColor="#D57DFF"/>
<stop offset="1" stopColor="#F4C5FF"/>
</linearGradient>
</defs>
)}
</svg>


  );
};
export default ShapeLIA;
